// extracted by mini-css-extract-plugin
export var stickyWrapper = "header-module--sticky-wrapper--nXpX7";
export var isSticky = "header-module--is-sticky--QZ6bg";
export var header = "header-module--header--eORMa";
export var menuContainer = "header-module--menu-container--Bm3HW";